/* Look Showcase carousel — transform slider, arrows + dots, video autoplay on active slide */
(function () {
  if (customElements.get('look-showcase')) return;

  class LookShowcase extends HTMLElement {
    constructor() {
      super();
      this.index = 0;
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
      this.prevBtn = this.querySelector('[data-carousel-prev]');
      this.nextBtn = this.querySelector('[data-carousel-next]');
      this.scroller = this.querySelector('.look-showcase__product-scroller');
    }

    connectedCallback() {
      this.initDragScroll();

      if (!this.track || this.slides.length <= 1) {
        this.playActiveVideo();
        return;
      }

      this.prevBtn && this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.go(parseInt(dot.dataset.index, 10)));
      });

      // Touch swipe (가로 우세 제스처만 슬라이드 전환 → 세로 스크롤 시 오작동 방지)
      let startX = 0;
      let startY = 0;
      let dragging = false;
      this.track.addEventListener(
        'touchstart',
        (e) => {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          dragging = true;
        },
        { passive: true }
      );
      this.track.addEventListener(
        'touchend',
        (e) => {
          if (!dragging) return;
          dragging = false;
          const dx = e.changedTouches[0].clientX - startX;
          const dy = e.changedTouches[0].clientY - startY;
          // 가로 이동이 세로보다 크고 40px 이상일 때만 슬라이드 전환
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            this.go(dx < 0 ? this.index + 1 : this.index - 1);
          }
        },
        { passive: true }
      );

      this.update();
    }

    // 우측 상품 리스트: 마우스 클릭 드래그로 가로 롤링 (PDP 추천상품 UX 참고)
    initDragScroll() {
      const scroller = this.scroller;
      if (!scroller) return;

      let isDown = false;
      let startX = 0;
      let startScroll = 0;
      let moved = false;
      const DRAG_THRESHOLD = 5; // px 이상 이동해야 드래그로 간주

      scroller.addEventListener('pointerdown', (e) => {
        // 마우스 좌클릭만 (터치는 네이티브 스크롤 사용)
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.pointerType !== 'mouse') return;
        isDown = true;
        moved = false;
        startX = e.clientX;
        startScroll = scroller.scrollLeft;
      });

      scroller.addEventListener('pointermove', (e) => {
        if (!isDown) return;
        const dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > DRAG_THRESHOLD) {
          moved = true;
          // 실제 드래그 시작 시점에만 클래스 추가.
          // pointerdown에서 추가하면 pointer-events:none이 mousedown 타깃을 <a>에서 벗어나게 해
          // 단순 클릭 시 click 이벤트가 앵커에 전달되지 않아 PDP 이동이 막힘.
          scroller.classList.add('is-dragging');
          scroller.setPointerCapture(e.pointerId);
        }
        if (moved) {
          e.preventDefault();
          scroller.scrollLeft = startScroll - dx;
        }
      });

      const end = (e) => {
        if (!isDown) return;
        isDown = false;
        scroller.classList.remove('is-dragging');
        if (scroller.hasPointerCapture && e.pointerId != null && scroller.hasPointerCapture(e.pointerId)) {
          scroller.releasePointerCapture(e.pointerId);
        }
      };
      scroller.addEventListener('pointerup', end);
      scroller.addEventListener('pointercancel', end);

      // 드래그 후 카드 링크 클릭 방지
      scroller.addEventListener(
        'click',
        (e) => {
          if (moved) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );

      // 이미지/링크 기본 드래그(ghost) 항상 방지.
      // moved 판정 전(5px threshold 이내) 서브-threshold 이동에서 네이티브 드래그가
      // 먼저 시작되면 pointercancel로 첫 드래그가 취소됨 → 조건 없이 차단.
      scroller.addEventListener('dragstart', (e) => e.preventDefault());
    }

    go(next) {
      const max = this.slides.length - 1;
      this.index = Math.max(0, Math.min(next, max));
      this.update();
    }

    update() {
      this.track.style.transform = 'translateX(' + -this.index * 100 + '%)';
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
      if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.index === this.slides.length - 1;
      this.playActiveVideo();
    }

    playActiveVideo() {
      this.querySelectorAll('video').forEach((v) => {
        const slide = v.closest('[data-slide]');
        const active = slide && parseInt(slide.dataset.index, 10) === this.index;
        if (active) {
          v.play().catch(() => {});
        } else {
          v.pause();
        }
      });
    }
  }

  customElements.define('look-showcase', LookShowcase);
})();
